const TAB_ABOUT = 0;
const TAB_CONTRIBUTIONS = 1;
const TAB_CONTACT = 2;

const TAB_NAMES = ["About", "Contributions", "Contact"];

export {
    TAB_ABOUT, TAB_CONTACT, TAB_CONTRIBUTIONS, TAB_NAMES
}
